import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { CircleNumber } from 'components/MonitoringStat/MonitoringStatCircleNumber';
import { MonitoredQueuesList } from 'components/MonitoredQueuesList';
import { ViewModeSelector } from '../ViewModeSelector';
import { SearchComponent } from '../SearchComponent';
import { TripleDot } from '../TripleDot';
import DropdownVoiceChannelSelector from '../DropdownVoiceChannelSelector';
import * as S from '../../styles';

export const MonitoringHeader = ({
  systemConfiguration,
  circleStats,
  onCircleClick,
  groups,
  selectedGroup,
  onSelectGroup,
  onClearGroup,
  manualSelection,
  onManualChange,
  allQueues,
  onGroupsChanged,
  searchState,
  onToggleSearch,
  onSearchChange,
  queuesLoginResponse,
  setSortOption,
  layoutOption,
  setLayoutOption,

  activeFilters,
  allVoiceChannels,
  selectedVoiceChannels,
  setSelectedVoiceChannels
}) => {
  return (
    <S.AgentStatsHeader
      backgroundColor={systemConfiguration?.primary_color || '#191A1E'}
      borderRadius={systemConfiguration?.border_radius}
    >
      <S.AgentCirclesContainer>
        {circleStats
          .filter((c) => c.id !== 'total_agents')
          .map((props) => {
            const isFaded =
              activeFilters && activeFilters.length > 0 && !props.isActive;
            return (
              <div
                key={`agent-${props.id}`}
                id={props.id}
                className={`circle-wrapper ${
                  props.clickable ? 'clickable' : ''
                }`}
                onClick={() => onCircleClick(props)}
                title={props.title}
                style={{
                  cursor: props.clickable ? 'pointer' : 'default',
                  opacity: isFaded ? 0.4 : 1,
                  transform: props.isActive ? 'scale(1.05)' : 'scale(1)',
                  transition: 'all 0.2s ease-in-out',
                  borderRadius: '50%',
                  padding: '2px'
                }}
              >
                <CircleNumber {...props} />
              </div>
            );
          })}

        {circleStats.find((c) => c.id === 'total_agents') && (
          <>
            <S.VerticalSeparator />
            {(() => {
              const totalProps = circleStats.find(
                (c) => c.id === 'total_agents'
              );
              return (
                <div
                  key={`agent-${totalProps.id}`}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <div
                    style={{
                      transform: 'scale(1)',
                      borderRadius: '50%',
                      padding: '2px'
                    }}
                  >
                    <CircleNumber {...totalProps} />
                  </div>
                  <S.TotalLabel>{totalProps.title}</S.TotalLabel>
                </div>
              );
            })()}
          </>
        )}
      </S.AgentCirclesContainer>

      <S.HeaderActions>
        <DropdownVoiceChannelSelector
          voiceChannels={allVoiceChannels}
          selectedVoiceChannels={selectedVoiceChannels}
          onChange={setSelectedVoiceChannels}
          iconColor="#FFF"
        />
        <ViewModeSelector
          groups={groups}
          selectedGroup={selectedGroup}
          onSelectGroup={onSelectGroup}
          onClearGroup={onClearGroup}
          manualSelection={manualSelection}
          onManualChange={onManualChange}
          iconColor="#FFF"
          allQueues={allQueues}
          onGroupsChanged={onGroupsChanged}
        />
        <SearchComponent
          isActive={searchState?.isActive}
          searchValue={searchState?.value}
          onToggle={onToggleSearch}
          onChange={onSearchChange}
        />
        <MonitoredQueuesList
          queueNames={queuesLoginResponse || []}
          iconColor="#FFF"
        />
        <TripleDot
          setSortOption={setSortOption}
          setLayoutOption={setLayoutOption}
          layoutOption={layoutOption}
          iconColor="#FFF"
        />
      </S.HeaderActions>
    </S.AgentStatsHeader>
  );
};
